<template>
    <div class="list-header" :style='"background-image:" + banner + ";"'>
        <div class="list-title">同{{listHeader}}表现</div>
        <div class="list-name">{{focus}}</div>
        <div class="index-box">
            <div class="index-item" :key="item.id" v-for="item in indexData">
                <div class="index">{{item.name}}</div>
                <div class="value">{{item.value}}{{item.unit}}</div>
            </div>
        </div>
        <div class="news">{{news}}</div>
    </div>
</template>

<script>
export default {
    name: 'listHeader',
    data (){
        return {
            focus: '--',
            listHeader: "--",
            banner: "url('./images/list-banner/related-industry.png')",
            indexData: [
                {index: '平均超额认购倍数', value: 77.88, unit:"倍"},
                {index: '平均上市首日涨幅', value: 77.88, unit:"%"},
                {index: '上涨比例', value: 77.88, unit:"%"},
            ],
            news: ''
        }
    },
    methods: {
        getQuery: function (name) {
            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            let r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            };
            return null;
        },
        getData: function(focus){
            let url = location.protocol+"//"+location.hostname+"/api/youyu-ipo-list/"+this.getQuery("dimension")+"-info";
            this.$http.get(url,{params:{
                startDate:this.getQuery("startDate"),
                endDate:this.getQuery("endDate"),
                focus:this.focus
            }}).then((response)=>{
                console.log(response.data);
                this.indexData =response.data.data.data;
            })
        }
    },
    watch:{
        focus: function (newValue, oldValue){
            this.getData(newValue);
        }
    },
    created(){
        this.banner= "url('./images/related-list/"+this.getQuery("dimension")+".png')";
    }
}
</script>

<style lang="scss" scoped>
.list-header {
    position: relative;
    padding: .4rem;
    overflow: hidden;
    font-family: 'Noto Sans SC', sans-serif;
    color:#fff;
    text-align: left;
    background-position: top center;
    background-size: 100% auto;
    background-repeat: no-repeat;
}

.list-title {
    position: relative;
    width: 2.48rem;
    height: 0.33rem;
    padding-left: 0.11rem;
    margin: 0rem 0rem .12rem;
    background: linear-gradient(90deg, rgba(255, 255, 255, .5), rgba(255, 255, 255, 0));
    font-family: 'Noto Sans SC', sans-serif;
    font-size: .24rem;
    font-weight: 400;
    line-height: .33rem;
}

.list-name {
    height: .85rem;
    margin: 0.12rem 0rem .48rem;
    font-size: .4rem;
    font-weight: 700;
}

.index-box {
    display: flex;
    display: -webkit-flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin: .48rem 0rem .5rem;
}

.index-item {
    text-align: center;
}

.index {
    font-size: .24rem;
    font-weight: 400;
    line-height: .33rem;
    color: #fff;
}

.value {
    font-family: DINAlternate, 'Noto Sans SC', sans-serif;
    font-size: .36rem;
    font-weight: 400;
    color: #FFCB00;
}

.news {
    font-family: 'Noto Sans SC', sans-serif;
    font-size: .2rem;
    font-weight: 300;
    color: #fff;
    opacity: .6;
}
</style>

